/* =========================================================================
   ENDEX GROUP — endex-transition.js | Page transitions: "Cell cascade"
   Leaving: the screen breaks into the site grid (8 columns, square cells, the
   same 12.5vw lines as the fx-grid backdrop). Cells flash orange and go dark in
   a wave spreading out from wherever you tapped. The destination name scrambles
   in over a loading bar, then the next page loads.
   Arriving: the grid is already dark, and the cells collapse into the loader's
   small white squares and blink out, centre first, onto the new page.
   Only transform and opacity are animated, so phones stay smooth.
   Only internal page links trigger it. New tabs, downloads, anchors, mail/phone
   links, modifier-clicks, cart/checkout and the theme editor are left alone.
   Reduced motion: off entirely.
   ========================================================================= */
(function(){
  'use strict';
  var html=document.documentElement;
  var REDUCE=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SIG=(window.EndexFXConfig&&window.EndexFXConfig.sig)||'#FF5A1F';
  if(REDUCE||(window.Shopify&&window.Shopify.designMode)||!Element.prototype.animate){html.classList.remove('fx-tx-in');return;}

  var COLS=8, E='cubic-bezier(.19,1,.22,1)', E2='cubic-bezier(.65,0,.35,1)';
  var css=
  '#fxtx{position:fixed;inset:0;z-index:200;pointer-events:none;visibility:hidden;overflow:hidden}'+
  '#fxtx.on{visibility:visible;pointer-events:auto}'+
  '#fxtx .c{position:absolute;background:#070706;transform:scale(0);will-change:transform}'+
  '#fxtx .c i{position:absolute;inset:0;background:'+SIG+';opacity:0;will-change:opacity}'+
  '#fxtx .c b{position:absolute;inset:0;background:#F4F1EA;opacity:0}'+
  '#fxtx .mid{position:absolute;left:0;right:0;top:50%;transform:translateY(-50%);display:flex;flex-direction:column;align-items:center;gap:14px;opacity:0;z-index:2}'+
  '#fxtx .nm{font:600 clamp(2.4rem,7vw,5.6rem)/.9 "Chakra Petch","Archivo",system-ui,sans-serif;text-transform:uppercase;color:#F4F1EA;font-variant-numeric:tabular-nums;white-space:nowrap}'+
  '#fxtx .br{width:min(190px,40vw);height:2px;background:rgba(244,241,234,.15);position:relative;overflow:hidden}'+
  '#fxtx .br i{position:absolute;inset:0;background:#F4F1EA;transform-origin:left;transform:scaleX(0)}'+
  '#fxtx .pc{font:500 10px/1 "JetBrains Mono",monospace;letter-spacing:.2em;color:'+SIG+'}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);

  var el=document.createElement('div');el.id='fxtx';el.setAttribute('aria-hidden','true');
  var mid=document.createElement('div');mid.className='mid';
  mid.innerHTML='<span class="nm"></span><span class="br"><i></i></span><span class="pc">000%</span>';
  var nm=mid.querySelector('.nm'),bar=mid.querySelector('.br i'),pc=mid.querySelector('.pc');
  var cells=[];

  function mount(){ if(!el.parentNode) document.body.appendChild(el); }
  // Lay the grid over the current viewport. _d = distance from the tap (leaving), _c = distance from centre (arriving).
  function build(tx,ty){
    el.innerHTML=''; cells=[];
    var W=window.innerWidth,H=window.innerHeight,cw=W/COLS,R=Math.ceil(H/cw);
    var fx=tx==null?COLS/2:tx/cw, fy=ty==null?R/2:ty/cw;
    for(var y=0;y<R;y++)for(var x=0;x<COLS;x++){
      var c=document.createElement('span');c.className='c';
      c.style.cssText='left:'+(x*cw)+'px;top:'+(y*cw)+'px;width:'+(cw+1)+'px;height:'+(cw+1)+'px';
      c.innerHTML='<i></i><b></b>';
      c._d=Math.hypot(x+.5-fx,y+.5-fy); c._c=Math.hypot(x+.5-COLS/2,y+.5-R/2);
      el.appendChild(c); cells.push(c);
    }
    el.appendChild(mid); mid.style.opacity=0;
  }

  var GLYPHS='\u2593\u2592\u2591\u2588#/<>_-=+01';
  function scramble(text,dur){
    var t0=performance.now();
    (function f(now){var p=Math.min(1,(now-t0)/dur),rev=Math.floor(p*text.length*1.15),s='';
      for(var i=0;i<text.length;i++)s+=(i<rev||text[i]===' ')?text[i]:GLYPHS[(Math.random()*GLYPHS.length)|0];
      nm.textContent=s; if(p<1)requestAnimationFrame(f);else nm.textContent=text;})(t0);
  }
  function counter(dur,done){
    var t0=performance.now();
    (function f(now){var p=Math.min(1,(now-t0)/dur);pc.textContent=String(Math.round(p*100)).padStart(3,'0')+'%';
      if(p<1)requestAnimationFrame(f);else done();})(t0);
  }

  // What to call the page we're heading to: the link's own words if they're short, else the URL.
  function nameFor(a,u){
    var t=(a.getAttribute('aria-label')||a.textContent||'').replace(/\s+/g,' ').trim();
    if(t&&t.length<=16&&!/^\d/.test(t))return t.toUpperCase();
    var seg=u.pathname.replace(/\/+$/,'').split('/').filter(Boolean);
    if(!seg.length)return 'HOME';
    if(seg[0]==='cart')return 'CART';
    if(seg[0]==='collections'&&seg.length<=2)return (seg[1]==='all'?'SHOP':seg[1].replace(/[-_]+/g,' ')).toUpperCase().slice(0,16);
    return seg[seg.length-1].replace(/[-_]+/g,' ').toUpperCase().slice(0,16);
  }

  var busy=false;
  function leave(href,label,x,y){
    if(busy)return; busy=true; mount(); build(x,y);
    el.classList.add('on');
    var max=0;
    cells.forEach(function(c){
      var d=c._d*34; if(d>max)max=d;
      c.animate([{transform:'scale(0)'},{transform:'scale(1.02)',offset:.45},{transform:'scale(1)'}],{duration:360,delay:d,easing:E,fill:'forwards'});
      c.firstChild.animate([{opacity:1},{opacity:1,offset:.45},{opacity:0}],{duration:360,delay:d,fill:'forwards'});
    });
    setTimeout(function(){
      mid.style.opacity=1; scramble(label,340);
      bar.animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}],{duration:380,easing:E2,fill:'forwards'});
      counter(380,function(){
        try{ sessionStorage.setItem('fxTx','1'); }catch(e){}
        location.href=href;
      });
    },Math.min(max+220,700));
  }

  // Arriving: the head script already painted the screen black (html.fx-tx-in), so lay a dark grid over it,
  // drop the paint, then collapse the cells into small white squares and blink them out, centre first.
  // Other scripts (page intros, scroll scenes) wait on this so they play after the cascade, not underneath it.
  window.EndexTx={arriving:false};
  function done(){ if(!window.EndexTx.arriving)return; window.EndexTx.arriving=false; document.dispatchEvent(new Event('endex:tx-done')); }
  function arrive(){
    window.EndexTx.arriving=true;
    mount(); build(null,null);
    cells.forEach(function(c){c.style.transform='scale(1)';});
    el.classList.add('on');
    el.offsetWidth;
    html.classList.remove('fx-tx-in');
    var last=0;
    cells.forEach(function(c){
      var d=80+c._c*38; if(d>last)last=d;
      c.animate([{transform:'scale(1)'},{transform:'scale(.16)',offset:.55},{transform:'scale(.16)',offset:.7},{transform:'scale(0)'}],{duration:520,delay:d,easing:E2,fill:'forwards'});
      c.lastChild.animate([{opacity:0},{opacity:0,offset:.55},{opacity:1,offset:.7},{opacity:1}],{duration:520,delay:d,fill:'forwards'});
    });
    setTimeout(done,last*.55+300);   // most of the grid has cleared by here: start the page's own intro
    setTimeout(function(){ el.classList.remove('on'); el.innerHTML=''; cells=[]; done(); },last+560);
  }

  function internal(a,e){
    if(!a||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return false;
    if(a.target&&a.target!=='_self')return false;
    if(a.hasAttribute('download')||a.hasAttribute('data-no-tx')||a.closest('[data-no-tx]'))return false;
    var raw=a.getAttribute('href')||'';
    if(!raw||raw.charAt(0)==='#'||/^(mailto|tel|sms|javascript):/i.test(raw))return false;
    var u; try{ u=new URL(a.href,location.href); }catch(x){ return false; }
    if(u.origin!==location.origin)return false;
    if(u.pathname===location.pathname&&u.search===location.search)return false;   // same page, maybe a hash jump
    if(/^\/(cart\/(add|change|update|clear)|account\/logout|checkout|checkouts)/.test(u.pathname))return false;
    return u;
  }

  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href]');
    var u=internal(a,e); if(!u)return;
    e.preventDefault();
    leave(u.href,nameFor(a,u),e.clientX||null,e.clientY||null);
  },true);

  // Start fetching the next page the moment a finger or cursor lands on a link, so the cascade hides the load.
  var pre={};
  function prefetch(e){
    var a=e.target.closest&&e.target.closest('a[href]'); if(!a)return;
    var u=internal(a,{button:0}); if(!u||pre[u.href])return; pre[u.href]=1;
    var l=document.createElement('link'); l.rel='prefetch'; l.href=u.href; document.head.appendChild(l);
  }
  document.addEventListener('pointerdown',prefetch,{passive:true,capture:true});
  document.addEventListener('mouseover',prefetch,{passive:true});

  // Back/forward can restore a page from memory mid-transition; make sure it comes back clear.
  window.addEventListener('pageshow',function(e){
    if(e.persisted){ busy=false; el.classList.remove('on'); el.innerHTML=''; cells=[]; html.classList.remove('fx-tx-in'); }
  });

  if(html.classList.contains('fx-tx-in')){
    document.readyState==='loading'?document.addEventListener('DOMContentLoaded',arrive):arrive();
  }
})();
